import script from "./zchsz.vue?vue&type=script&setup=true&lang=js"
export * from "./zchsz.vue?vue&type=script&setup=true&lang=js"

import "./zchsz.vue?vue&type=style&index=0&id=24e24aa2&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24e24aa2"]])

export default __exports__